import { render, staticRenderFns } from "./TierSelect.vue?vue&type=template&id=5320032d&"
import script from "./TierSelect.vue?vue&type=script&lang=ts&"
export * from "./TierSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports